import styled from 'styled-components';

export const Header = styled.div`
    padding:10px;
`;

export const Body = styled.div`
    padding: 10px;
    .typeButtons{
        display: flex;
        gap: 10px;

        button{
            &.selected{
                background: #000;
                color: #fff;
            }
        }
    }

    .footerButtons{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 20px;

        button{
            width: 100px;
            border: none;
            background: #efefef;

            &.confirm{
                background: var(--blueColor1);
                color: #fff;
            }
        }
    }
`;